export default __webpack_public_path__ + "static/media/header.ff40b9cb.svg";